import axiosInstance from "../configuration/request";

export const editUser = async (payload, userId, showSnackbar) => {
  try {
    const res = await axiosInstance.patch(`customer/users/${userId}`, payload);
    return res;
  } catch (error) {
    if (error?.response?.data?.message) {
      showSnackbar(error.response.data.message, "error");
    } else {
      showSnackbar("Something went wrong!", "error");
    }
    throw error; // propagate error so caller can catch
  }
};
